import { Mangel } from '../model/mangel';

// -- 1. Data from Backend ------------------------------------------------------------------------
export const MANGEL_STORE_OBJECTS = 'MANGEL_STORE_OBJECTS';

// -- 2. Reset State ------------------------------------------------------------------------------
export const MANGEL_RESET_STATE_ALL = 'MANGEL_RESET_STATE_ALL';

// -- 3. Selection --------------------------------------------------------------------------------
export const MANGEL_SELECT_ITEM = 'MANGEL_SELECT_ITEM';

// -- 4. Item Management --------------------------------------------------------------------------
export const MANGEL_SET_TOADD = 'MANGEL_SET_TOADD';
export const MANGEL_SET_TOEDIT = 'MANGEL_SET_TOEDIT';
export const MANGEL_SET_TODELETE = 'MANGEL_SET_TODELETE';
export const MANGEL_ADD_ITEM = 'MANGEL_ADD_ITEM';
export const MANGEL_EDIT_ITEM = 'MANGEL_EDIT_ITEM';
export const MANGEL_DELETE_ITEM = 'MANGEL_DELETE_ITEM';

// -- 5. JsonSchema -------------------------------------------------------------------------------
export const MANGEL_STORE_DETAIL_JSS = 'MANGEL_STORE_DETAIL_JSS';


// ------------------------------------------------------------------------------------------------
// action creators
// ------------------------------------------------------------------------------------------------

// -- 1. Data from Backend ------------------------------------------------------------------------
export function mangelStoreStockObjects(maengel: Mangel[]) {
   return { type: MANGEL_STORE_OBJECTS, payload: {itemSet: maengel}};
}

// -- 2. Reset State ------------------------------------------------------------------------------
export function mangelResetStateAll() {
return { type: MANGEL_RESET_STATE_ALL, payload: '' };
}

// -- 3. Selection --------------------------------------------------------------------------------
export function mangelSelectStock(mangel: Mangel) {
return { type: MANGEL_SELECT_ITEM, payload: {selectedItem: mangel}};
}

// -- 4. Item Management -------------------------------------------------------------------------
export function mangelSetItemGroupToAdd(mangel: Mangel) {
    return { type: MANGEL_SET_TOADD, payload: {itemToAdd: mangel }};
 }
export function mangelSetItemGroupToEdit(mangel: Mangel) {
   return { type: MANGEL_SET_TOEDIT, payload: {itemToEdit: mangel }};
}
export function mangelSetItemToDelete(mangel: Mangel) {
   return { type: MANGEL_SET_TODELETE, payload: {itemToDelete: mangel }};
}
export function mangelAddItem(mangel: Mangel) {
   return { type: MANGEL_ADD_ITEM, payload: {itemAdd: mangel }};
}
export function mangelEdidItem(mangel: Mangel) {
   return { type: MANGEL_EDIT_ITEM, payload: {itemEdit: mangel }};
}
export function mangelDeleteItem(mangel: Mangel) {
   return { type: MANGEL_DELETE_ITEM, payload: {itemDelete: mangel }};
}

// -- 5. Json Schema ------------------------------------------------------------------------------
export function mangelStoreDetailJss(mangelDetailJss: any) {
   return { type: MANGEL_STORE_DETAIL_JSS, payload: {jss: mangelDetailJss }};
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/store/actions.ts